import { render } from "./HomeGallery.vue?vue&type=template&id=6c2ce8d2&scoped=true"
import script from "./HomeGallery.vue?vue&type=script&lang=js"
export * from "./HomeGallery.vue?vue&type=script&lang=js"

import "./HomeGallery.vue?vue&type=style&index=0&id=6c2ce8d2&scoped=true&vars=%7BimgDimension%7D&lang=css"
script.render = render
script.__scopeId = "data-v-6c2ce8d2"

export default script